import { useOriginResolver } from '@resolve-js/react-hooks';
import createContextBasedConnector from './create-context-based-connector';
var connectRootBasedUrls = createContextBasedConnector(useOriginResolver);
export { connectRootBasedUrls };
//# sourceMappingURL=connect-root-based-urls.js.map